'use strict';
import { Component, Inject, Input, EventEmitter, Output} from 'ng-metadata/core';
import {SendEmailService} from './sendEmail.service';
import {JwtUtilService} from '../../../security/jwtUtil.service';
import {StorageUtil} from "../../../infra/storageUtil.service";
import {getCaptcha} from '../../../appConfig/appConfigForward';
import {PrimoResponse} from '../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import { RtaService } from '../../rta.service';
import { ExportAllService } from '../../actions/exportAll/exportAll.service';
import { PrimolyticsService } from '../../../analytics/primolytics.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import { isEqual } from 'lodash';
import { SearchService } from '../../search.service';

const _get = require('lodash/get');
const _findIndex = require('lodash/findIndex');
const cloneDeep = require('lodash/cloneDeep');

var angular:angular.IAngularStatic =  require('angular');
enum scopeTypes {
    LOCAL = 'Local',
    CDI = 'CDI',
    BLENDED = 'Blended'
}

@Component({
    providers: [SendEmailService],
    "selector": 'prm-send-email',
    templateUrl: 'components/search/actions/sendEmailAction/send-email.html'
})



export class PrmSendEmail{
    @Input() item: PrimoResponse.IDoc[];
    @Input() selectedIds: any;
    @Input() isFullView: boolean;
    @Input() isExportAll: boolean;
    @Input() totalResults: number;
    @Output() finishedEmailEvent = new EventEmitter<void>();

    private emailRegExAll = /^(([a-zA-Z0-9\.\!\#\$\%\&\'\*\+\-\/\=\?\^\_\`\{\|\}\~]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;|,]\s*(([a-zA-Z0-9\.\!\#\$\%\&\'\*\+\-\/\=\?\^\_\`\{\|\}\~]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    private urlPattern = /((http|https|ftp|smtp|rtsp):\/\/|www\.)/i;
    private htmlPattern=/([<>])/i;
    
    private addresses='';
    private honeypot = '';
    subject: string;
    note: string;
    gCaptchaResponse : string;
    // captchaSelected: boolean =true;

    _sendMailInProgress : boolean;
    public showPreview: boolean = false;
    private totalResultsAsString: string;
  

    constructor(private sendEmailService: SendEmailService,
                private jwtUtilService: JwtUtilService,
                private storageUtil: StorageUtil,
                private rtaService: RtaService,
                private exportAllService: ExportAllService,
                private primolyticsService: PrimolyticsService,
                private configUtil : ConfigurationUtil,
                private searchService : SearchService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$q') private $q: ng.IQService,
                @Inject('$stateParams') private $stateParams : angular.ui.IStateParamsService){

        if (this.isUser()) {
            this.storageUtil.$localForage.getItem('userDetails').then((data) => {
                this.addresses = data !== null ? data.email : '';
            });
        }
        this.$translate('email.itemsfound').then((translation)=>{
            this.subject= translation;
        });
        this.note= '';
        this._sendMailInProgress = false;
        if(this.sendEmailService.isTemplateSupported(this.itemsToArray(this.selectedIds))){
            this.templateRenderingInProgress = true;
            this.sendEmailService.getPnxForSelectedIds(this.selectedIds).then((response) => {
                let pnxs = response.data || [];
                let sortedPnxs = pnxs.sort((a,b) => _findIndex(this.selectedIds, (o) => {return _get(o, 'recordId') === _get(a, 'pnx.search.addsrcrecordid[0]')}) -
                _findIndex(this.selectedIds, (o) => {return _get(o, 'recordId') === _get(b, 'pnx.search.addsrcrecordid[0]')}));
                this.item = sortedPnxs;
                this.rtaService.updateAvailability(this.item);
            });
        }else if(this.sendEmailService.isTemplateSupported(this.itemsToArray(this.item))){
            this.templateRenderingInProgress = true; 
        }
        else{
            this.templateRenderingInProgress = false; 
        }

        if (this.isExportAll){
            //For export all email section - display the total results num using the locale seperators (comma, space, dot,...)
            let norm_lang = this.$translate.use().replace("_", "-"); 
            norm_lang = norm_lang === 'pt1' ? 'pt-PT' : norm_lang;  // URM-231457
            this.totalResultsAsString = this.totalResults.toLocaleString(norm_lang);
        }
    }

    get emailRegEx() {
        return this.emailRegExAll;
    }
    
    get capchaPublicKey(){
        return getCaptcha().public_key;
    }
    
    get isCaptcha(){
        if( getCaptcha().isActiveCapcha=='Y') {
            return true;
        }else{
            return false;
        };
    }  
 
    private disableHtml(element) {
        this.note = this.note.replace(this.htmlPattern, '');
        this.note = this.note.replace(this.urlPattern, '');
    }
    
    private successfullSendAction(event, response) {
        console.log("email successfully sent");
        this._sendMailInProgress = false;
        this.finishedEmailEvent.emit(null); //throw event so action list directive can close the email form
    }

    private failedSendAction(event, response) {
        console.log("email failed to send");
        this._sendMailInProgress = false;
        this.finishedEmailEvent.emit(null); //throw event so action list directive can close the email form
    }

    private isUser() {
        return this.jwtUtilService.isSignedIn();
    }
    private isGuest() {
        return this.jwtUtilService.isGuest();
    }

    sendEmail(event) {
        if (!this.isFormValid(event)){
            return;
        }

        this._sendMailInProgress = true;
        if (this.isExportAll){
            this.runBeacon(this.exportAllService.exportOption);
            let encodingOrFiletypeToSend = this.exportAllService.encodingOrFormatVal;
            if (isEqual(undefined,encodingOrFiletypeToSend)){
                encodingOrFiletypeToSend = isEqual(this.exportAllService.EXCEL,this.exportAllService.exportOption) ? this.exportAllService.default_filetype : this.exportAllService.default_encoding;
            }
            let headers = isEqual(this.exportAllService.exportOption, this.exportAllService.EXCEL) ? this.exportAllService.excelHeaders : {};
            this.sendEmailService.sendExportAllEmail(this.addresses.split(/,|;/),this.subject,this.note,this.gCaptchaResponse, this.exportAllService.exportOption, encodingOrFiletypeToSend,headers);
            this.finishedEmailEvent.emit(null); //throw event so searchResultToolBar directive can close the export all form
            return;
        }
        
        let failedAction = angular.bind(this, this.failedSendAction, event);
        let successAction = angular.bind(this, this.successfullSendAction, event);

        let records = Array.isArray(this.item) ? cloneDeep(this.item) : [cloneDeep(this.item)];
        let promiseArray = [];

        records.forEach(record => {
            if(_get(record, 'pnx.display.source')) {
                let sourceCodes = _get(record, 'pnx.display.source');
                sourceCodes.forEach((sourceCode, i) => {
                    promiseArray.push(this.getSourceTranslate(record, i));
                });
            }
        }); 
        
        this.$q.all(promiseArray).then(() => { 
            let sendEmailPromise = this.sendEmailService.sendEmail(this.addresses.split(/,|;/), this.subject, this.note, [records],this.gCaptchaResponse,this.selectedIds, this.isFullView);
            sendEmailPromise.then((response)=>successAction(response), (response)=>failedAction(response));
        });
    }

    private getSourceTranslate(record,i) {
        let sourceCodes = _get(record, 'pnx.display.source');
        return this.$translate('fulldisplay.datasource.' + sourceCodes[i],[], '', sourceCodes[i]).then((translate) => {
            record.pnx.display.source[i] = translate; 
        });
    }

    private isFormValid(event){
        return this.emailRegEx.test(this.addresses) && this.subject && this.isRecipientNumberValid() && this.isNoteSecured() && this.isCaptchaSet(event) && !this.honeypot;
    }
    
    
    private isNoteSecured(){
        return !this.urlPattern.test(this.note) && !this.htmlPattern.test(this.note);
    }
    
    private isRecipientNumberValid(){
        if (!this.addresses){
            return true;
        }
        let recipients=this.addresses.split(/,|;/);
        if(this.isUser()){
            if (recipients.length <=10){
                return true;
            }else{
                return false;
            } 
        }else{
            if(recipients.length <=1){
                return true;
            }else{
                return false;
            }
        }
    }
    
    private setWidgetId(widgetId){
        //console.log("Get widgetId from capture:"+widgetId);
        
    }
    
    private isCaptchaSet(event){
        if (this.isCaptcha){
            if(this.gCaptchaResponse){
                //event.$error.recaptchaResponse=false;
//              this.captchaSelected=true;
                return true;
            }else{
                //event.$error.recaptchaResponse=true;
//              this.captchaSelected=false;
                return false;
            }
        }else{
            //event.$error.recaptchaResponse=false;
//          this.captchaSelected=true;
            return true;
        }
    }

    
    
    private setResponse(response){
        //console.log("Get response from capture:"+response);
        this.gCaptchaResponse=response;
    }
    
    private changeAddress(emailForm){
        if(!this.isRecipientNumberValid()){
            emailForm.addresses.$error.validationError = true;
        }else{
            emailForm.addresses.$error.validationError = false;
        }
        
    }
    private changeNote(emailForm){
        
        if(this.urlPattern.test(this.note) || this.htmlPattern.test(this.note)){
            emailForm.note.$error.validationError = true;
        }else{
            emailForm.note.$error.validationError = false;
        }
        
    }

    public itemsToArray(item): any[]{
        return (!item || Array.isArray(item)) ? item : [item];
    }
    
    get sendMailInProgress() :boolean{
        return this._sendMailInProgress;
    }

    public goToEmailTemplate() {
        this.showPreview = !this.showPreview;
    }

    get renderedItems(): string {
        return this.sendEmailService.renderedItems;
    }

    set renderedItems(items: string) {
        this.templateRenderingInProgress = false;
        this.sendEmailService.renderedItems = items;
    }

    get templateRenderingInProgress(): boolean {
        return this.sendEmailService.templateRenderingInProgress ;
    }

    set templateRenderingInProgress(inProgress: boolean) {
        this.sendEmailService.templateRenderingInProgress = inProgress;
    }

    public showCaptchaError(emailForm): boolean {
        return emailForm.$error.recaptcha || !this.gCaptchaResponse;
    }

    private recaptchaPublicKeyIsNotValid() {
        return this.isCaptcha && !this.recaptchaIframeExists();
    }

    private recaptchaIframeExists() {
        return document.querySelector('iframe[title="reCAPTCHA"]');
    }

    public getRecaptchaErrorMessage(): String {
        return this.recaptchaPublicKeyIsNotValid() ? 'captcha.invalidSiteKey' : 'captcha.notselected';
    }

    get totalResultsNum(){
        return this.totalResultsAsString;
    }

    get isTotalResultsForExportAllExceeded() {
        let limit = isEqual(this.calculateScopeType(), scopeTypes.BLENDED) ? this.exportAllService.recordsLimitForBlended : this.exportAllService.recordsLimit;
        return this.totalResults > limit;
    }

    public getNumberOfResultsPlaceHolder(){
        let resultsAsString = this.totalResultsNum;
        if (this.isSuprima){   //Primo VE
            if (isEqual(this.calculateScopeType(), scopeTypes.BLENDED)){
                let totalResultsLocal = this.searchService.getResultObject().info.totalResultsLocal;
                let totalResultsPC = this.searchService.getResultObject().info.totalResultsPC;
                let localForCalculation = totalResultsLocal > this.exportAllService.recordsLimit ? this.exportAllService.recordsLimit : totalResultsLocal;
                let cdiForCalculation = totalResultsPC > this.exportAllService.recordsLimit ? this.exportAllService.recordsLimit : totalResultsPC;
                let results =  localForCalculation + cdiForCalculation;
                let norm_lang = this.$translate.use().replace("_", "-");
                norm_lang = norm_lang === 'pt1' ? 'pt-PT' : norm_lang;  // URM-231457
                resultsAsString = results.toLocaleString(norm_lang);
            } 
        }
        
        return {idx_0:resultsAsString};
    }

    public getNumberOfResultsPlaceHolderExceeded(){
        let results = 0;
        if (this.isSuprima){   //Primo VE
            if (isEqual(this.calculateScopeType(), scopeTypes.BLENDED)){
                let totalResultsLocal = this.searchService.getResultObject().info.totalResultsLocal;
                let totalResultsPC = this.searchService.getResultObject().info.totalResultsPC;
                let localForCalculation = totalResultsLocal > this.exportAllService.recordsLimit ? this.exportAllService.recordsLimit : totalResultsLocal;
                let cdiForCalculation = totalResultsPC > this.exportAllService.recordsLimit ? this.exportAllService.recordsLimit : totalResultsPC;
                results =  localForCalculation + cdiForCalculation;
            } else {
                results = this.exportAllService.recordsLimit;
            }
            
        }
        else { //Classic Primo
            results = isEqual(this.calculateScopeType(), scopeTypes.BLENDED) ? this.exportAllService.recordsLimitForBlended : this.exportAllService.recordsLimit;
        }
        let norm_lang = this.$translate.use().replace("_", "-");
        let resultsAsString = results.toLocaleString(norm_lang);
        
        return {idx_0:resultsAsString};
    }

    private runBeacon(exportOption) {
        let operation = '';
        switch (exportOption) {
            case this.exportAllService.EXCEL:
                operation = 'sendAllRecordsExcel';
                break;
            case this.exportAllService.BIBTEXPUSHTO:
                operation = 'sendAllRecordsBibtex';
                break;
            case this.exportAllService.RISPUSHTO:
                operation = 'sendAllRecordsRIS';
                break;
    
        }
		this.primolyticsService.doBeaconReport({
			'p': 'brief',
			'op': operation
		}, this.primolyticsService.getTimestamp());
	}

    public isScopeIncludesNonSupportedSearchEngine() { //for Export All - is the scope includes search scope other than Local and CDI
        let tab = this.$stateParams['tab'];
        let searchScope = this.$stateParams['search_scope'];
        let scopesInformation = window.appConfig['primo-view']['scopes'];
        let targetScope = scopesInformation.find(scope => isEqual(scope.tab, tab) && isEqual(scope["scope-id"], searchScope));

        if (!targetScope) {
            return false; // Scope not found, return false
        }

        let locations = targetScope.locations.split(',');
        
        if (this.isSuprima){   //Primo VE
            return locations.some(loc => !isEqual('primo_central_multiple_fe', loc) && !isEqual('Local', loc));     
        }
        else {                              //Classic Primo
            return locations.some(loc => !isEqual('primo_central_multiple_fe', loc) && !loc.startsWith('scope:('));
        }
    }


    private calculateScopeType() { //for Export All - is the scope Local, CDI or Blended
        let tab = this.$stateParams['tab'];
        let searchScope = this.$stateParams['search_scope'];
        let scopesInformation = window.appConfig['primo-view']['scopes'];
        let targetScope = scopesInformation.find(scope => isEqual(scope.tab, tab) && isEqual(scope["scope-id"], searchScope));

        if (!targetScope) {
            return scopeTypes.LOCAL; // Scope not found, return default
        }

        let locations = targetScope.locations.split(',');

        if (this.isSuprima){   //Primo VE
            let filteredLocations = locations.filter(loc => isEqual(loc, "Local") || isEqual(loc, "primo_central_multiple_fe"));
            if (filteredLocations.includes("Local") && filteredLocations.includes("primo_central_multiple_fe")) {
                return scopeTypes.BLENDED;
            } else if (filteredLocations.includes("Local")) {
                return scopeTypes.LOCAL;
            } else if (filteredLocations.includes("primo_central_multiple_fe")) {
                return scopeTypes.CDI;
            } 
        }
        else {                              //Classic Primo
            let filteredLocations = locations.filter(loc => loc.startsWith('scope:(') || isEqual(loc, "primo_central_multiple_fe"));
            if (filteredLocations.some(loc => loc.startsWith('scope:(')) && filteredLocations.includes("primo_central_multiple_fe")) {
                return scopeTypes.BLENDED;
            } else if (filteredLocations.some(loc => loc.startsWith('scope:('))) {
                return scopeTypes.LOCAL;
            } else if (filteredLocations.includes("primo_central_multiple_fe")) {
                return scopeTypes.CDI;
            }
        }

        return scopeTypes.LOCAL;
    }

    get isSuprima(){
        return this.configUtil.isSuprima();
    }

}







// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/sendEmailAction/sendEmail.directive.ts